import { cn } from "@/lib/utils";

/**
 * Full-area empty state. Replaces the repeated BookOpen/Users icon + CTA
 * patterns across ReportFolders, SharedReportFolders, Dashboard, etc.
 *
 * Usage:
 *   <EmptyState
 *     icon={BookOpen}
 *     title="No Report Folders yet"
 *     description="Create your first Report Folder to start generating report cards."
 *     action={<Button onClick={...}>+ New Report Folder</Button>}
 *   />
 *
 * icon - any Lucide (or compatible) icon component. Rendered at 40×40.
 * action - any React node, typically a Button.
 */
function EmptyState({ icon: Icon, title, description, action, className }) {
  return (
    <div className={cn(
      "flex flex-col items-center justify-center py-20 px-6 text-center",
      className
    )}>
      {Icon && (
        <div className="mb-5 flex h-14 w-14 items-center justify-center rounded-full bg-muted">
          <Icon className="h-7 w-7 text-muted-foreground" strokeWidth={1.5} />
        </div>
      )}
      <h3 className="font-display text-xl font-normal text-foreground mb-2">
        {title}
      </h3>
      {description && (
        <p className="text-sm font-sans text-muted-foreground leading-normal max-w-xs mb-6">
          {description}
        </p>
      )}
      {action && action}
    </div>
  );
}

export { EmptyState };
